// extracted by mini-css-extract-plugin
export var background = "_6c-0";
export var container = "_6c-1";
export var contentItem = "_6c-7";
export var extendedWarranty = "_6c-5";
export var link = "_6c-d";
export var modal = "_6c-b";
export var modalCloseButton = "_6c-9";
export var modalContent = "_6c-3";
export var modalContentMain = "_6c-6";
export var modalImageLogo = "_6c-8";
export var modalLogo = "_6c-a";
export var modalSideImage = "_6c-4";
export var preview = "_6c-c";
export var redoModal = "_6c-2";